(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('TaskType', TaskType);

    TaskType.$inject = ['$resource', 'DateUtils'];

    function TaskType ($resource, DateUtils) {
        var resourceUrl =  'api/task-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TaskTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.gettasktypebyname = function (data,callback){
		$http.get('api/task-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TaskTypeSearch', TaskTypeSearch);

    TaskTypeSearch.$inject = ['$resource'];

    function TaskTypeSearch ($resource) {
        var service = $resource('/api/task-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomTaskTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-task-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();